import { Component, Input, OnInit } from '@angular/core';
import { SNSMSMessage } from 'src/app/models/snsmsmessage';

@Component({
  selector: 'app-sms-row',
  templateUrl: './sms-row.component.html',
  styleUrls: ['./sms-row.component.scss']
})
export class SmsRowComponent implements OnInit {

  @Input() message: SNSMSMessage;

  constructor() { }

  ngOnInit(): void {
  }

}
